/**
 * @generated SignedSource<<149a357c96fd2a9abf773a7bc0250e69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomFieldValueInput = {
  id?: string | null;
  entityId?: string | null;
  entityType?: string | null;
  key?: string | null;
  value?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateCustomFieldListValueMutation$variables = {
  input: UpdateCustomFieldValueInput;
};
export type updateCustomFieldListValueMutation$data = {
  readonly updateCustomFieldValue: {
    readonly customFieldValue: {
      readonly node: {
        readonly id: string;
        readonly key: string;
        readonly value: string | null;
      } | null;
    } | null;
  } | null;
};
export type updateCustomFieldListValueMutation = {
  variables: updateCustomFieldListValueMutation$variables;
  response: updateCustomFieldListValueMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCustomFieldListValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateCustomFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldValueV2TypeEdge",
            "kind": "LinkedField",
            "name": "customFieldValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCustomFieldListValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateCustomFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldValueV2TypeEdge",
            "kind": "LinkedField",
            "name": "customFieldValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc8dabab240ba126f4b04dea6508fde0",
    "id": null,
    "metadata": {},
    "name": "updateCustomFieldListValueMutation",
    "operationKind": "mutation",
    "text": "mutation updateCustomFieldListValueMutation(\n  $input: UpdateCustomFieldValueInput!\n) {\n  updateCustomFieldValue(input: $input) {\n    customFieldValue {\n      node {\n        __typename\n        id\n        key\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "94e2f7766a2229cee407ecdbaf96c310";

export default node;
